import * as React from 'react'
import { Input, Select } from 'uxp/components'
import ActionEditorLink, { extractAction, IAction, IActionEditorLinkSettings } from '../action-editor/ActionEditor'
import { IBaseProperty, IUIPropertyDefinition } from '../common'
import IconEditor from '../icon-selector/IconEditor'
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle } from './common'
import jp from 'jsonpath'
import { hasProperty, hasValue, parseValue } from '../../../util'
import { WidgetDesignerPillInput } from '../pill-input/PillInput'

interface IButtonPropertyProps extends IBaseProperty {
    label: string,
    onClick: IAction,
    color?: string,
    backgroundColor?: string,
    icon?: {
        icon: string
        position?: 'left' | 'right',
        color?: string,
        size?: string
    }
}

export function extractButtonProperties(props: IButtonPropertyProps, defaultLabel?: string) {

    if (!defaultLabel) defaultLabel = 'Click'
    if (!props) return { label: defaultLabel, onClick: extractAction(null) }

    let label = hasValue(props.label) ? props.label : defaultLabel
    let onClick = extractAction(props.onClick)


    let buttonStyles: React.CSSProperties = {}
    if (hasValue(props.color)) buttonStyles.color = props.color
    if (hasValue(props.backgroundColor)) buttonStyles.backgroundColor = props.backgroundColor


    let icon: string = null
    let iconPosition: 'left' | 'right' = null
    let iconStyles: React.CSSProperties = {}
    if (hasProperty(props, "$.icon")) {
        if (hasValue(props.icon.icon)) icon = props.icon.icon
        if (hasValue(props.icon.position)) iconPosition = props.icon.position
        if (hasValue(props.icon.size)) iconStyles.fontSize = props.icon.size
        if (hasValue(props.icon.color)) iconStyles.color = props.icon.color

    }

    return { label, onClick, icon, iconPosition, buttonStyles, iconStyles }
}

export function ButtonProperty(props: IButtonPropertyProps, title?: string, actionEditorSettings?: IActionEditorLinkSettings): IUIPropertyDefinition<IButtonPropertyProps> {

    return {
        defaults: props,
        render: (props, uxpContext, contextData, containerId, customProps) => {

            let _props = props?.uiProps || { label: 'Click', onClick: { type: 'open-url' } }

            return <PropertyContainer>
                <PropertyContainerTitle>{title || 'Button'}</PropertyContainerTitle>

                <PropertyGroup>
                    <PropertyGroupTitle>Button</PropertyGroupTitle>
                    <Property>
                        <PropertyTitle>Label</PropertyTitle>
                        {/* <Input
                            value={_props.label || ''}
                            onChange={s => {
                                jp.apply(_props, '$.label', () => (s))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                        /> */}

                        <WidgetDesignerPillInput
                            value={_props.label || ''}
                            onChange={s => {
                                jp.apply(_props, '$.label', () => (s))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                            contextData={contextData}
                        />
                    </Property>

                    <Property>
                        <PropertyTitle>On click</PropertyTitle>
                        <ActionEditorLink
                            uiProps={props.parentUIProps}
                            designer={props.designer}
                            action={_props.onClick}
                            onChange={s => {
                                jp.apply(_props, '$.onClick', () => (s))
                                props.onChange(_props)
                            }}
                            uxpContext={uxpContext}
                            settings={actionEditorSettings}
                            contextData={contextData}
                        />
                    </Property>

                    {hasProperty(_props, '$.color') &&
                        <Property>
                            <PropertyTitle>Text Color</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={_props.color || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.color', () => (s))
                                    props.onChange(_props)
                                }}
                            />
                        </Property>
                    }

                    {hasProperty(_props, '$.backgroundColor') &&
                        <Property>
                            <PropertyTitle>Background Color</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={_props.backgroundColor || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.backgroundColor', () => (s))
                                    props.onChange(_props)
                                }}
                            />
                        </Property>
                    }
                </PropertyGroup>

                {hasProperty(_props, '$.icon') &&
                    <PropertyGroup>
                        <PropertyGroupTitle>Icon</PropertyGroupTitle>

                        <Property>
                            <PropertyTitle>Icon</PropertyTitle>
                            <IconEditor
                                value={_props.icon.icon}
                                onChange={s => {
                                    jp.apply(_props, '$.icon.icon', () => (s))
                                    props.onChange(_props)
                                }}
                            />

                        </Property>

                        {hasProperty(_props, '$.icon.position') &&
                            <Property>
                                <PropertyTitle>Position </PropertyTitle>
                                <Select
                                    selected={_props.icon.position || 'left'}
                                    options={[
                                        { label: 'Left', value: 'left' },
                                        { label: 'Right', value: 'right' },
                                    ]}
                                    onChange={s => {
                                        jp.apply(_props, '$.icon.position', () => (s))
                                        props.onChange(_props)
                                    }}
                                />
                            </Property>
                        }

                        {hasProperty(_props, '$.icon.color') &&
                            <Property>
                                <PropertyTitle>Color </PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={_props.icon.color}
                                    onChange={s => {
                                        jp.apply(_props, '$.icon.color', () => (s))
                                        props.onChange(_props)
                                    }}
                                />
                            </Property>
                        }
                        {hasProperty(_props, '$.icon.size') &&
                            <Property>
                                <PropertyTitle>Size (px) </PropertyTitle>
                                <Input
                                    type='number'
                                    value={escapeUnit(_props.icon.size || '', 'px')}
                                    onChange={s => {
                                        let num = Number(s) || 0
                                        if (num < 8) s = '8'
                                        else if (num > 200) s = '200'

                                        jp.apply(_props, '$.icon.size', () => (s + 'px'))
                                        props.onChange(_props)
                                    }}
                                    className="widget-designer-input"
                                    inputAttr={{
                                        max: '200',
                                        min: '8'
                                    }}
                                />
                            </Property>
                        }

                    </PropertyGroup>
                }
            </PropertyContainer>

        }
    }

}